import classNames from 'classnames';
import InputMask from '@mona-health/react-input-mask';
import Label from './text/label';
import Text from './text';
import SVGIcon, { IIcons } from './icons';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
	label?: string;
	mask?: string;
	maskPlaceholder?: string;
	containerClassName?: string;
	icon?: IIcons;
	iconClassName?: string;
	iconContainerClassName?: string;
	onIconClick?: () => void;
}

const Input = ({
	label,
	containerClassName,
	className,
	mask,
	maskPlaceholder = '',
	icon,
	iconClassName,
	iconContainerClassName,
	onIconClick,
	placeholder,
	value,
	disabled,
	required,
	...props
}: InputProps) => (
	<div
		className={classNames(
			'flex flex-col relative group',
			containerClassName
		)}
	>
		{label && (disabled || value) && (
			<Label className="absolute -top-2 text-xs bg-white group-focus-within:text-primary left-3 px-1">
				{label}
			</Label>
		)}
		{placeholder && !value && (
			<Text
				className={classNames(
					'text-ellipsis whitespace-nowrap text-gray-label select-none absolute flex top-1/2 -translate-y-1/2 pl-3 cursor-text pointer-events-none',
					{
						invisible: disabled,
					}
				)}
			>
				{placeholder}
				{required && <Text className="text-red ml-1">*</Text>}
			</Text>
		)}
		<InputMask
			className={classNames(
				'focus:border-primary outline-primary py-2 no-number-spinner border border-gray-border rounded-md',
				{
					'bg-[#EFEFEF4D]': disabled,
					'px-3': !className?.includes('px-'),
				},
				className
			)}
			mask={mask}
			maskPlaceholder={maskPlaceholder}
			value={value}
			disabled={disabled}
			required={required}
			{...props}
		/>
		{icon && (
			<div
				className={classNames(
					'absolute top-1/2 -translate-y-1/2 right-1 size-8',
					iconContainerClassName
				)}
				onClick={onIconClick}
			>
				<SVGIcon
					className={classNames(
						'absolute h-4 w-auto top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 fill-gray-label group-focus-within:fill-primary',
						iconClassName
					)}
					icon={icon}
				/>
			</div>
		)}
	</div>
);

export default Input;
